import { downloadInternalAuditChecklistAttachment } from '../../../api/internalAudit';
import {
  InternalAuditChecklist,
  InternalAuditChecklistItem,
} from '../../../types/internalAudit';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import { PreviewAttachmentList } from './previewShared';

interface Props {
  detail: InternalAuditChecklist;
}

function newId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function parseItems(json?: string | null): InternalAuditChecklistItem[] {
  if (!json?.trim()) return [];
  try {
    const parsed = JSON.parse(json);
    if (!Array.isArray(parsed) || parsed.length === 0) return [];
    return parsed.map((row: Partial<InternalAuditChecklistItem>) => ({
      id: row.id || newId(),
      standard: row.standard || 'ISO',
      clause: row.clause || '',
      question: row.question || '',
      evidence: row.evidence || '',
      result: row.result || '',
      finding: row.finding || '',
    }));
  } catch {
    return [];
  }
}

function resultLabel(result?: string) {
  if (result === 'CONFORM') return '적합';
  if (result === 'OFI') return '관찰(OFI)';
  if (result === 'NC') return '부적합';
  return '미판정';
}

function InternalAuditChecklistPreviewView({ detail }: Props) {
  const items = parseItems(detail.itemsJson);

  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>체크시트</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label>
            체크시트번호
            <input readOnly value={detail.checklistNo || ''} />
          </label>
          <label>
            연결 계획서
            <input readOnly value={detail.planTitle || '-'} />
          </label>
          <label>
            심사일
            <input type="date" readOnly value={detail.auditDate || ''} />
          </label>
          <label className="is-span-2">
            제목
            <input readOnly value={detail.title || ''} />
          </label>
          <label>
            심사원
            <input readOnly value={detail.auditorName || ''} />
          </label>
        </div>

        <div style={{ marginTop: 16 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>점검 항목</strong>
            <p className="quality-form__hint" style={{ margin: '4px 0 0' }}>
              {items.length}건
            </p>
          </div>
          <div className="edu-plan-table-wrap ia-checklist-wrap">
            <table className="edu-plan-table ia-checklist-table">
              <thead>
                <tr>
                  <th className="col-no">No</th>
                  <th className="col-std">구분</th>
                  <th className="col-clause">조항/항목</th>
                  <th className="col-question">확인질문</th>
                  <th className="col-evidence">증빙</th>
                  <th className="col-result">판정</th>
                  <th className="col-finding">발견사항</th>
                </tr>
              </thead>
              <tbody>
                {items.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="ia-checklist-empty">
                      등록된 점검 항목이 없습니다.
                    </td>
                  </tr>
                ) : (
                  items.map((item, idx) => (
                    <tr key={item.id}>
                      <td className="is-center col-no">{idx + 1}</td>
                      <td className="col-std">
                        <input readOnly value={item.standard || ''} />
                      </td>
                      <td className="col-clause">
                        <input readOnly value={item.clause} />
                      </td>
                      <td className="col-question">
                        <input readOnly value={item.question} />
                      </td>
                      <td className="col-evidence">
                        <input readOnly value={item.evidence} />
                      </td>
                      <td className="col-result">
                        <input readOnly value={resultLabel(item.result)} />
                      </td>
                      <td className="col-finding">
                        <input readOnly value={item.finding} />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="quality-form__grid" style={{ marginTop: 12 }}>
          <label className="is-span-2">
            비고
            <textarea rows={2} readOnly value={detail.remark || ''} />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <div className="edu-plan-card__title" style={{ marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>첨부파일</h3>
        </div>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) => {
            void downloadInternalAuditChecklistAttachment(
              detail.checklistId,
              file.attachmentId,
              file.fileName
            );
          }}
        />
      </section>
    </div>
  );
}

export default InternalAuditChecklistPreviewView;
